import '../styles.css';
import PageTitle from '../../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../../components/Accessibility/DefaultText';
import VoltarButton from '../../../../components/Accessibility/VoltarButton';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getAgendamentosSaudeEmocional, getCVPrestador, getPrestadores } from '../../../../services/SaudeBemEstar/SaudeEmocionalService';
import WhiteContainer from '../../../../components/Accessibility/WhiteContainer';
import { Agendamento } from '../../../../interfaces/entities/Agendamento';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarLines } from '@fortawesome/pro-duotone-svg-icons';
import { CircularProgress, Divider } from '@mui/material';
import { cancelarAgendamento } from '../../../../services/AgendamentoService';
import CancelarModal from './CancelarModal/CancelarModal';
import { sxAgendamentoCard } from '../sxProps';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { dateToText } from '../../../../utils/MonthMap';

const MeusAgendamentosPsico: React.FC = () => {

  const navigate = useNavigate();

  const [agendamentos, setAgendamentos] = useState<Agendamento[]>([]);
  const [agendamento, setAgendamento] = useState<Agendamento | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [showCancelarModal, setShowCancelarModal] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  useEffect(() => {
    loadAgendamentos()
  }, [])

  const handleReagendarClicked = (ag: Agendamento) => {
    setLoading(true);
    getPrestadores()
      .then(async (prestadores) => {
        const prestador = prestadores.find(p => p.idInstal === ag.idInstal && p.idPessoa === ag.idPrestador)
        if (prestador) {
          const cv = await getCVPrestador(prestador.idPessoa)
          prestador.curriculo = cv
          navigate('/saudeBemEstar/unimedAcolhe/agendamentos/agendar', { state: { prestadorInfo: prestador, agendamento: ag } });
        }
      })
      .catch(console.log)
      .finally(() => { setLoading(false) });
  }

  const handleCancelarRequest = (ag: Agendamento) => {
    setAgendamento(ag);
    setShowCancelarModal(true);
  }


  const handleCancelarConfirm = (ag: Agendamento | null) => {
    setShowCancelarModal(false);
    setLoading(true);
    if (!ag) return;
    cancelarAgendamento(ag.idInstal, ag.id)
      .then(_ => {
        setModalFeedback({
          icon: 'success',
          closeAction: () => navigate('/saudeBemEstar/unimedAcolhe'),
          title: 'Cancelado',
          subTitle: 'Seu atendimento foi cancelado com sucesso!',
          textButton: 'Fechar',
          showButtonModal: true,
          buttonAction: () => navigate('/saudeBemEstar/unimedAcolhe')
        });

      })
      .catch(error => {
        setModalFeedback({
          icon: 'error',
          closeAction: () => setModalFeedback(null),
          title: 'Ocorreu um erro',
          subTitle: 'Falha ao cancelar atendimento!',
          textButton: 'Fechar',
          showButtonModal: true,
          buttonAction: () => setModalFeedback(null)
        });
      }).finally(() => setLoading(false))
  }

  const loadAgendamentos = () => {
    setLoading(true);
    getAgendamentosSaudeEmocional()
      .then(agendamentos => {
        setAgendamentos(agendamentos)
      })
      .catch(console.log)
      .finally(() => { setLoading(false); })
  }

  const availableNow = (agendamento: Agendamento): boolean => {
    return agendamento.statusTelemedicina === 'disponivel' && agendamento.statusTelemedicinaAPI === 'Iniciada';
  }

  const handleClickIngressarNoAtendimento = (agendamento: Agendamento) => {
    navigate(`/saudeOnline/ingressarNoAtendimento/${agendamento.idReuniao}`);
  }

  return (
    <div className='page-container'>

      <PageTitle text="Agendamentos" />

      {
        !!loading &&
        <div className="width-100-pc flex-row justify-center">
          <CircularProgress />
        </div>
      }

      {
        !loading && agendamentos.map(ag => (
          <WhiteContainer shadow key={ag.id} sx={sxAgendamentoCard}>
            <FontAwesomeIcon icon={faCalendarLines} className="fa-icon32x32" />
            <div className="flex-col gap-20 width-100-pc">
              <DefaultText text={`<b>Profissional:</b> ${ag.nomeMedico}`} />
              <DefaultText text={`<b>Especialidade:</b> ${ag.especialidade}`} />
              <Divider />
              <DefaultText text={`<b>Data e hora da consulta:</b> ${ag.dataAgendamento} ${ag.horaAgendamento}`} />
              <div className="flex-mobile gap-20">
                <DefaultButton
                  aria-label={availableNow(ag) ? `Ingressar no atendimento` : `Alterar data e hora da consulta com ${ag.nomeMedico}, especialista em ${ag.especialidade}, em ${dateToText(ag.dataAgendamento)} às ${ag.horaAgendamento}`}
                  text={availableNow(ag) ? 'Ingressar no atendimento' : 'Alterar data e hora'}
                  onClick={() => availableNow(ag) ? handleClickIngressarNoAtendimento(ag) : handleReagendarClicked(ag)} />
                <DefaultButton
                  variant='outlined'
                  text="Cancelar agendamento"
                  aria-label={`Cancelar agendamento com ${ag.nomeMedico}, especialista em ${ag.especialidade}, em ${dateToText(ag.dataAgendamento)} às ${ag.horaAgendamento}`}
                  onClick={() => handleCancelarRequest(ag)} />
              </div>
            </div>
          </WhiteContainer>
        ))
      }

      <CancelarModal
        showModal={showCancelarModal}
        onConfirmarClick={handleCancelarConfirm}
        onVoltarClick={() => { setShowCancelarModal(false) }}
        agendamento={agendamento}
      />
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
        classNameModal="modal-custom"
      />
      <VoltarButton onClick={() => { navigate('/saudeBemEstar/unimedAcolhe') }} />
    </div>
  )
}

export default MeusAgendamentosPsico;